import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
import { useCallback, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { CheckoutContext } from "Root/checkout/CheckoutRoutes";
import DrawerComponent from "Root/profile/components/common/DrawerComponent";
import UnderlinedButton from "Root/profile/components/common/UnderlinedButton";
import { GainfulButton } from "Root/checkout/components";
import updateFlavors from "../../Checkout/helpers/updateFlavors";
import { useFlavors } from "../../Checkout/hooks";
import FlavorSelectScreen from "../../FlavorSelectScreen";
import { ProteinNavBar } from "../components";
import styles from "./styles.module.css";
import { updateUserCart } from "Root/checkout/redux/slices/checkoutUserCartSlice";
import { useDispatch } from "react-redux";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
const FlavorsPage = () => {
    const history = useHistory();
    const isMobile = useScreenWidth() < 999;
    const dispatch = useDispatch();
    const { cart, userCart, error_message, setUserCart, setUpdatingFlavors, checkoutPages } = useContext(CheckoutContext);
    const [proteinData, setProteinData] = useState(null);
    const [flavorCounts, setFlavorCounts] = useState({});
    const [showFlavorsScreen, setShowFlavorsScreen] = useState(false);
    const [showHowFlavorsWork, setShowHowFlavorsWork] = useState(false);
    const [addonAttributes, setAddonAttributes] = useState(null);
    const [isValid, setIsValid] = useState(false);
    const [chosenFlavorsString, setChosenFlavorsString] = useState(null);
    const { addFlavor, addProteinFlavor, proteinFlavors, hydrationFlavors, preworkoutFlavors, flavorLimits, personalizedProducts, } = useFlavors({ error_message, addonAttributes, setAddonAttributes });
    // Callback that all flavors should update: run request
    const updateAllFlavors = () => {
        updateFlavors({
            cart,
            proteinFlavors,
            error_message,
            preworkoutFlavors,
            hydrationFlavors,
            flavorLimits,
            addonAttributes,
            setUserCart: (data) => {
                setUserCart(data);
                dispatch(updateUserCart(data));
            },
            setUpdatingFlavors,
        });
    };
    const goNext = () => {
        setUpdatingFlavors(true);
        updateAllFlavors();
        history.push(checkoutPages[checkoutPages.indexOf("/checkout/protein-flavors/") + 1]);
    };
    useEffect(() => setProteinData(userCart.find((item) => item.item_type === "protein") || null), [userCart]);
    useEffect(() => {
        if (proteinFlavors) {
            const updatedFlavorCounts = Object.fromEntries(proteinFlavors.map(({ short_name, count }) => [short_name, count || 0]));
            setFlavorCounts(updatedFlavorCounts);
        }
    }, [proteinFlavors]);
    const adjustProteinFlavor = useCallback((newAmount, shortname) => {
        addProteinFlavor && addProteinFlavor(shortname, flavorCounts, true, flavorLimits.protein, "protein", newAmount);
    }, [addProteinFlavor, flavorCounts, flavorLimits]);
    const validateProtein = (flavorsObj, limit) => {
        const count = Object.values(flavorsObj).reduce((prev, curr) => prev + curr, 0);
        return count === limit;
    };
    useEffect(() => {
        if (history.location.hash === "#showflavors") {
            setShowFlavorsScreen(true);
        }
    }, []);
    useEffect(() => {
        setIsValid(validateProtein(flavorCounts, flavorLimits.protein));
    }, [flavorCounts, flavorLimits]);
    useEffect(() => {
        const str = personalizedProducts.find((item) => item.item_type === "protein")?.flavor_attribute_description || null;
        setChosenFlavorsString(str);
    }, [personalizedProducts]);
    const retakeQuiz = () => {
        history.push("/users/retake-quiz/");
        window.location.reload();
    };
    const showFlavorsSelectScreen = () => {
        setShowFlavorsScreen(true);
    };
    const hideFlavorsSelectScreen = () => {
        setShowFlavorsScreen(false);
    };
    const openDrawer = () => {
        setShowHowFlavorsWork(true);
    };
    const closeDrawer = () => {
        setShowHowFlavorsWork(false);
    };
    const selectedFlavNum = Object.values(flavorCounts)
        .filter((num) => num > 0)
        .reduce((sum, curr) => sum + curr, 0);
    return (_jsxs("div", { className: styles.page, children: [!showFlavorsScreen && (_jsxs(_Fragment, { children: [_jsx(ProteinNavBar, { nextDisabled: !isValid }), _jsx("div", { className: styles.heading, children: "Choose flavors" }), _jsxs("p", { className: styles.subheading, children: ["All flavors are 100% plant-based,", _jsx("br", {}), "sweetened with organic stevia and monkfruit and include no artificial ingredients."] }), proteinData && (_jsx("div", { className: styles.flavorbox, children: _jsxs("div", { className: styles.inner, children: [_jsx("div", { className: styles.image, children: _jsx("img", { src: proteinData.image_url, alt: "protein" }) }), _jsx("div", { className: styles.label, children: "Choose Protein flavors" }), _jsx("button", { className: styles.flavorselect, type: "button", onClick: showFlavorsSelectScreen, children: chosenFlavorsString ? (_jsxs(_Fragment, { children: [chosenFlavorsString, " ", _jsx("span", { className: styles.arrow, children: "\u276F" })] })) : (_jsxs(_Fragment, { children: ["Select flavors ", _jsx("span", { className: styles.arrow, children: "\u276F" })] })) })] }) }))] })), showFlavorsScreen && (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.flavorswrap, children: [_jsx("div", { className: styles.flavorsheader, children: _jsx("div", { className: styles.flavorsnav, children: _jsx("button", { className: styles.cancelbtn, onClick: hideFlavorsSelectScreen, type: "button", children: "Cancel" }) }) }), _jsxs("div", { className: styles.flavorsinner, children: [_jsx("div", { className: styles.heading, children: `Choose ${flavorLimits ? flavorLimits.protein : ""} Protein Flavors` }), _jsxs("p", { className: styles.subheading, children: ["All flavors are 100% plant-based,", _jsx("br", {}), "sweetened with organic stevia and monkfruit and include no artificial ingredients.", _jsx("br", {}), _jsx("br", {}), _jsx(UnderlinedButton, { label: "HOW FLAVORS WORK", onClick: openDrawer })] }), _jsx(FlavorSelectScreen, { isProteinFlavors: true, flavors: proteinFlavors, useCounter: true, maxFlavors: flavorLimits.protein, flavorCounts: flavorCounts, isDeskThirdGridView: true, adjustProteinFlavor: adjustProteinFlavor, shortName: "protein", showNutritionFacts: true, adjustFlavor: addFlavor, view: undefined, setProductVariant: () => null, productName: "" })] }), _jsx("div", { className: styles.flavorsbottom, children: _jsxs("div", { className: styles.flavorsbottomnav, children: [_jsx(UnderlinedButton, { extraClassName: styles.retakebtn, label: "Retake Quiz", onClick: retakeQuiz }), _jsx(GainfulButton, { extraClassName: styles.continueBtn, text: !isValid ? `${selectedFlavNum}/${flavorLimits.protein} selected` : "Continue", onClick: goNext, disabled: !isValid, style: {
                                                background: `linear-gradient(106deg, rgba(51, 51, 51, 1) ${(selectedFlavNum / flavorLimits.protein) * 100}%, rgba(173, 168, 157) 0%)`,
                                            } })] }) })] }), _jsx(DrawerComponent, { open: showHowFlavorsWork, toggleDrawer: () => closeDrawer, anchor: isMobile ? "bottom" : "right", crossButton: true, children: _jsx("div", { className: styles.drawerinner, children: _jsx("p", { children: "Add your liquid to a Gainful BlenderBottle - we recommend using 8 oz of ice-cold milk or plant-based milk, but you can also use water with ice. Scoop in 1 to 2 scoops of protein, add your desired flavor boost, shake vigorously, and enjoy immediately." }) }) })] }))] }));
};
export default FlavorsPage;
